import { render, staticRenderFns } from "./VulnerabilityDetails.vue?vue&type=template&id=3f9c54ec&scoped=true&"
import script from "./VulnerabilityDetails.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityDetails.vue?vue&type=script&lang=js&"
import style0 from "./VulnerabilityDetails.vue?vue&type=style&index=0&id=3f9c54ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9c54ec",
  null
  
)

export default component.exports